import { render } from "./SideNavbar.vue?vue&type=template&id=ca8ed174"
import script from "./SideNavbar.vue?vue&type=script&lang=js"
export * from "./SideNavbar.vue?vue&type=script&lang=js"

import "./SideNavbar.vue?vue&type=style&index=0&id=ca8ed174&lang=css"
script.render = render

export default script